import { render, staticRenderFns } from "./BtnAssinarPcm.vue?vue&type=template&id=2d650d92"
import script from "./BtnAssinarPcm.vue?vue&type=script&lang=ts"
export * from "./BtnAssinarPcm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports